import(/* webpackMode: "eager", webpackExports: ["HotelStoreProvider"] */ "/app/src/shared/stores/hotel-store/HotelStoreProvider.tsx");
